import { createReducer } from '@reduxjs/toolkit';
import {
  fetchMakesStarted,
  fetchMakesSucceeded,
  fetchMakesFailed,
  setMakes,
  fetchFamiliesStarted,
  fetchFamiliesSucceeded,
  fetchFamiliesFailed,
  setFamilies,
  fetchVehiclesStarted,
  fetchVehiclesSucceeded,
  fetchVehiclesFailed,
  setVehicles,
  fetchVariantsStarted,
  fetchVariantsSucceeded,
  fetchVariantsFailed,
  setVariants,
  setAttachments,
} from '../../actions/vehicle_link';

export const initialState = {
  segments: [],
  makes: {},
  families: {},
  vehicles: {},
  variants: {},
  attachments: [],
  fetchingStatus: {
    makes: false,
    families: false,
    vehicles: false,
    variants: false,
  },
};

const VehicleLinkReducer = createReducer(initialState, {
  [fetchMakesStarted]: (state) => {
    state.fetchingStatus = {
      ...state.fetchingStatus,
      makes: true,
    };
  },

  [fetchMakesSucceeded]: (state) => {
    state.fetchingStatus = {
      ...state.fetchingStatus,
      makes: false,
    };
  },

  [fetchMakesFailed]: (state) => {
    state.fetchingStatus = {
      ...state.fetchingStatus,
      makes: false,
    };
  },

  [setMakes]: (state, action) => {
    const { code, makes } = action.payload;

    state.makes[code] = makes;
  },

  [fetchFamiliesStarted]: (state) => {
    state.fetchingStatus = {
      ...state.fetchingStatus,
      families: true,
    };
  },

  [fetchFamiliesSucceeded]: (state) => {
    state.fetchingStatus = {
      ...state.fetchingStatus,
      families: false,
    };
  },

  [fetchFamiliesFailed]: (state) => {
    state.fetchingStatus = {
      ...state.fetchingStatus,
      families: false,
    };
  },

  [setFamilies]: (state, action) => {
    const { cacheKeyName, families } = action.payload;

    state.families[cacheKeyName] = families;
  },

  [fetchVehiclesStarted]: (state) => {
    state.fetchingStatus = {
      ...state.fetchingStatus,
      vehicles: true,
    };
  },

  [fetchVehiclesSucceeded]: (state) => {
    state.fetchingStatus = {
      ...state.fetchingStatus,
      vehicles: false,
    };
  },

  [fetchVehiclesFailed]: (state) => {
    state.fetchingStatus = {
      ...state.fetchingStatus,
      vehicles: false,
    };
  },

  [setVehicles]: (state, action) => {
    const { params, vehicles } = action.payload;
    const cacheKeyName = `${params.code}_${params.makeCode}_${params.familyCode}_${params.bodyStyleCode}`;

    state.vehicles[cacheKeyName] = vehicles;
  },

  [fetchVariantsStarted]: (state) => {
    state.fetchingStatus = {
      ...state.fetchingStatus,
      variants: true,
    };
  },

  [fetchVariantsSucceeded]: (state) => {
    state.fetchingStatus = {
      ...state.fetchingStatus,
      variants: false,
    };
  },

  [fetchVariantsFailed]: (state) => {
    state.fetchingStatus = {
      ...state.fetchingStatus,
      variants: false,
    };
  },

  [setVariants]: (state, action) => {
    const { cacheKeyName, variants } = action.payload;

    state.variants[cacheKeyName] = variants;
  },

  [setAttachments]: (state, action) => {
    state.attachments = action.payload;
  },
});

export default VehicleLinkReducer;
